<template>
  <div class="card mb-3 border border-secondary shadow-sm">
    <div v-if="title" class="card-header text-start">
      <h3 class="mb-0 fs-4 fw-bold">{{ title }}</h3>
    </div>
    <div class="card-body">
      <p
        v-if="labContent.discussionQuestionsPrompt"
        class="mb-3 text-start alert alert-primary border-primary text-dark"
      >
        {{ labContent.discussionQuestionsPrompt }}
      </p>
      <div
        v-for="(question, index) in labContent.discussionQuestions"
        :key="index"
      >
        <div class="row">
          <div class="col-12 col-md-6">
            <label
              :for="'question-' + question.text + index"
              class="d-flex form-label text-start fw-bold"
            >
              <div
                v-html="
                  `${index + 1}. ${renderFormatSuperscriptOrSubscript(
                    question.text
                  )}`
                "
              />
            </label>
            <ul v-if="question.stepsList">
              <li
                v-for="step in question.stepsList"
                :key="step"
                class="lead text-start"
              >
                <div v-html="renderFormatSuperscriptOrSubscript(step)"></div>
              </li>
            </ul>
          </div>
          <div class="col">
            <div
              v-if="exportMode"
              class="
                text-start
                border border-dark
                bg-buck-tooth-white
                p-3
                rounded
              "
              style="white-space: pre-line"
            >
              {{ discussionAnswers[index].answer }}
            </div>
            <textarea
              v-else
              class="form-control border border-dark bg-buck-tooth-white"
              :id="'question-' + question.text + index"
              :placeholder="question.placeholder"
              :rows="question.rows"
              :value="discussionAnswers[index].answer"
              @input="
                updateDiscussionAnswers({
                  questionIndex: index,
                  value: $event.target.value
                })
              "
            ></textarea>
          </div>
        </div>
        <div
          v-if="index + 1 < labContent.discussionQuestions.length"
          class="mb-3"
        >
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormatAPI from "@/helpers/FormatAPI";

export default {
  name: "DiscussionQuestions",
  mixins: [FormatAPI],
  props: {
    labContent: Object,
    discussionAnswers: Array,
    exportMode: Boolean,
    title: {
      type: String,
      default: "Discussion Questions"
    }
  },
  emits: ["changeAnswers"],
  methods: {
    // Emit the updateDiscussionAnswers event to the parent component
    updateDiscussionAnswers(answer) {
      this.$emit("changeAnswers", {
        questionIndex: answer.questionIndex,
        answer: answer.value
      });
    }
  }
};
</script>
